<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<crucible-dialog
  [dialogTitle]="data.move.id ? 'Edit Move' : 'Add Move'"
  [form]="form"
  submitLabel="Save"
  [submitDisabled]="!data.canEdit || !form.valid || !form.dirty"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
@if (data && data.move) {
  <div crucibleDialogContent [formGroup]="form">
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field">
          <mat-label>Move Number</mat-label>
          <input matInput formControlName="moveNumber" />
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Move Description</mat-label>
          <input matInput formControlName="description" />
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="datetime-field">
          <mat-label>Situation Date / Time</mat-label>
          <input matInput [ngxMatDatetimePicker]="picker"
            [formControl]="situationDateFormControl" (inputChange)="saveMove('situationDate')"
            (dateChange)="saveMove('situationDate')" style="display: none;">
          <span (click)="data.canEdit && picker.open()">
            {{situationDateFormControl.value | date: 'dd MMM yyyy HH:mm'}} {{ getTimezoneAbbr(situationDateFormControl.value) }}
          </span>
          <mat-datepicker-toggle matSuffix title="Choose Date/Time" [for]="$any(picker)" [disabled]="!data.canEdit">
          </mat-datepicker-toggle>
          <ngx-mat-datetime-picker #picker [showSpinners]=true [showSeconds]=false [stepHour]=1 [stepMinute]=5
            [stepSecond]=1 [touchUi]=false [enableMeridian]=true [disableMinute]=false [hideTime]=false [color]="'warn'">
            <ngx-mat-datepicker-actions>
              <button mat-stroked-button ngxMatDatepickerApply>Save</button>
              <button mat-stroked-button ngxMatDatepickerCancel>Cancel</button>
            </ngx-mat-datepicker-actions>
          </ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
    </div>
      <div class="add-margin">
        <mat-label class="gray">Situation Description</mat-label>
        <angular-editor [placeholder]="'Enter situation description here...'" formControlName="situationDescription" [config]="editorConfig"></angular-editor>
      </div>
    </div>
  }
</crucible-dialog>
